
export const ACCOUNT_ACCESS = '/account-access';
export const ADMINISTRATION_USER_ACC = "/useraccounts-administration";
export const USER_ACC_REPORTS = "/useraccountreports";
export const USER_ACC_SEARCHABLEITEMS = "/useraccountsearchables";
export const currencies = "/currencies";
export const countries = "/countries";
export const subclients = "/subclients";
export const byAccountSummary = '/by-account-summary';
export const currencyAccounts = "/currency-accounts";
export const accounts = "/accounts";
export const accountsDetails = "/accounts/details";
export const transactions = "/transactions";
export const transactionsDownloads = "/transactionsdownload";
export const transactionsIndividualDownloads = "/transactionsindividualdownload";
export const intradaysDownloads = "/intradaysdownload";
export const statements = "/statements";
export const banks = "/banks";
export const groups = "/groups";
export const byCountySummary = "/by-country-summary";
export const byGroupSummary = "/by-group-summary";
export const balanceHistory = "/balance-history";
export const favorites = "/favorites";
export const userReports = "/userreports";
export const userReportfiles = "/userreportfiles";
export const USER_ACC_SUMMARIES = "/useraccountsummaries";
export const USER_ACC = "/useraccounts";
export const USER_ACC_REACT = "/useraccountsreact";
export const MT94X = "/mt94x";
export const CAMT05X = "/camt05x";
export const PDF = "/pdf";
export const FILTER = '/filter';
export const ZIP = "/zip";
export const deleteAccounts = "/delete-accounts";
export const intradays = "/intradays";
export const actualStatement = "/actual_statement";
export const actualIntraday = "/actual_intraday";
export const statementsCombined = "/statements-combined";
export const statementsSeparated = "/statements-separated";
export const allItems ="/all-items";
export const TRANSACTION_TYPES ="/transactiontypes";
export const USERREPORT_TYPES ="/userreporttypes";
export const VALUE_SERIES = "/valueseries";
export const VALUES = "/values";
export const VALUES_CHART = "/chart";
export const ERRONEOUS_STMTS = "/erroneous-statements";
export const ENUMS = "/enums";
export const NOTIFICATIONS = '/notifications';
export const count = "_count";
